export default __webpack_public_path__ + "static/media/screen3.ab11e420.png";